module.exports = {"TXTWCL_New_11":{"id":"TXTWCL_New_11","defaultMessage":"Novità"}}